import React from 'react';
import { Link2, Swords, Users, Share2 } from 'lucide-react';
import FeaturePage from './FeaturePage';

export default function PlayWithFriends() {
  return (
    <FeaturePage
      seo={{
        title: 'Play Football Manager With Friends Online | My Football Game',
        description: 'Challenge a friend to a football manager match with one link. They play your club in the browser, no signup needed. Rivalries, head-to-head records and more.',
        path: '/features/play-with-friends',
      }}
      eyebrow="Feature Spotlight"
      title="PLAY WITH "
      titleAccent="FRIENDS"
      subtitle="Send one link and your friend plays your club right away, in the browser, with no signup. Every match after that builds your rivalry."
      breadcrumbLabel="Play with Friends"
      sections={[
        {
          icon: <Link2 className="w-5 h-5" />,
          title: 'Challenge links: no signup to play',
          content: (
            <>
              <p>Every club gets its own challenge link. Send it on WhatsApp, Discord or anywhere else. Your friend opens it, sees your club and plays the match straight away, with no account and no download. You get a notification with the result.</p>
              <p>If they enjoy it, they can save the club they played with, using Google or an email address, and keep playing. Saving the club also makes you friends in the game automatically.</p>
            </>
          ),
        },
        {
          icon: <Swords className="w-5 h-5" />,
          title: 'Head-to-head rivalries',
          content: (
            <>
              <p>Every match between friends is recorded. Your friends list shows your all-time head-to-head record against each of them: wins, draws and losses. After a derby, both managers get the result together with the updated record.</p>
              <p>It turns a single match into an ongoing rivalry, which is where most of the fun is.</p>
            </>
          ),
        },
        {
          icon: <Users className="w-5 h-5" />,
          title: 'Friends in your division',
          content: (
            <>
              <p>Your friends' clubs join your <a href="/features/seasons" style={{ color: 'var(--accent)' }}>season</a> division and take the places of computer-managed clubs. You play each of them twice a season, and you can each play at your own pace.</p>
              <p>On the ranked ladder, you get a notification when a friend overtakes you in the same division.</p>
            </>
          ),
        },
        {
          icon: <Share2 className="w-5 h-5" />,
          title: 'Share cards',
          content: (
            <>
              <p>Results and challenge links show a preview card with both crests and the score when you share them in chats and on social media, so friends can see what they are being challenged to before they tap.</p>
              <p>For a longer competition, create a <a href="/features/leagues" style={{ color: 'var(--accent)' }}>private league</a> and invite your whole group.</p>
            </>
          ),
        },
      ]}
      faqItems={[
        { q: 'Can I play a football manager game with friends online for free?', a: 'Yes. My Football Game is free and runs in the browser. Send your challenge link to a friend and they can play your club straight away.' },
        { q: 'Does my friend need to create an account?', a: 'No. Your friend can play the challenge without signing up. Afterwards they can save the club with Google or an email address if they want to keep playing.' },
        { q: 'Do we need to be online at the same time?', a: 'No. Matches are simulated, so your friend can play your challenge link whenever they want and you get notified of the result.' },
        { q: 'Where do I find my challenge link?', a: 'In the game, open the Friends section. Your link is at the top with buttons to copy it or share it directly.' },
      ]}
      ctaTitle="Challenge your friends"
      ctaText="Create your club for free, then send your challenge link to the group chat."
    />
  );
}
